import * as yup from 'yup';
import {
	Row,
	RenderConfig,
	TextInput,
	AssetUploadInput,
	ASSET_TYPE,
	SelectInput,
	CheckboxInput,
	BULK_REFUND_CSV_LABEL
} from 'commons-ui';
import { GAME_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	CSV_NAME: 'csvName',
	DESCRIPTION: 'description',
	CSV_URL: ASSET_TYPE.CSV,
	GAME_NAME: 'gameName',
	USE_BULK_REFUND_V2: 'useBulkRefundV2'
};

export const validationSchema = yup.object().shape({
	gameName: yup.string().required('Game name is a required field'),
	csvName: yup.string().required('CSV Name is a required field'),
	description: yup.string().required('Description is a required field'),
	csv: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	})
});

const COLUMNS_NAME = ['zupeeUserId', 'ltid', 'freshdeskTicketId', 'playingAttempt'];
const COLUMNS_VALUES = [162030129345116, 164933521515325, 'CLS-3095', 1];
const downloadSampleCsvFile = () => {
	const csvString = [COLUMNS_NAME, COLUMNS_VALUES].map((e) => e.join(',')).join('\n');
	const csvContent = `data:text/csv;charset=utf-8,${csvString}`;
	const encodedUri = encodeURI(csvContent);

	const link = document.createElement('a');
	link.setAttribute('href', encodedUri);
	document.body.appendChild(link);

	return link;
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, options: GAME_OPTIONS, required: true }),

	[FORM_FIELD_KEYS.CSV_NAME]: new RenderConfig()
		.setName('csvName')
		.setLabel('CSV Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),

	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel(`Description (Special characters are not allowed eg: / , * , $, _ , - , etc )`)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.CSV_URL]: new RenderConfig()
		.setName(ASSET_TYPE.CSV)
		.setLabel(BULK_REFUND_CSV_LABEL)
		.setRenderer(AssetUploadInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			assetType: ASSET_TYPE.CSV,
			downloadFile: true,
			displayText: 'Sample CSV',
			link: downloadSampleCsvFile()
		}),
	[FORM_FIELD_KEYS.USE_BULK_REFUND_V2]: new RenderConfig()
		.setName('isBulkRefundV2')
		.setLabel('Use Bulk Refund V2')
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			checked: false
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.GAME_NAME),
	new Row(FORM_FIELD_KEYS.CSV_NAME),
	new Row(FORM_FIELD_KEYS.DESCRIPTION),
	new Row(FORM_FIELD_KEYS.CSV_URL),
	new Row(FORM_FIELD_KEYS.USE_BULK_REFUND_V2)
];
